import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EstoqueAmpService } from '../estoque-amp-service/estoque-amp.service';
import { Filtros } from '././../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '././../../../../shared/crud/ListaBase';
import { RetornoSelecao } from '././../../../../shared/gridview/RetornoSelecao';
import { Parametro } from '././../../../../shared/service-base/parametro';

@Component({
  selector: 'app-estoque-amp-lista',
  templateUrl: './estoque-amp-lista.component.html',
  styleUrls: ['./estoque-amp-lista.component.css']
})
export class EstoqueAmpListaComponent extends ListaBase implements OnInit {
  estoqueAMP: any;
  cols: any[];
  _selectedColumns: any[];
  parametrosFiltro: any;
  carregando: boolean;
  removeSelecionado = [];
  first = 0;
  rows = 10;

  dadosTranslate = {
    "Quantidade": "parametros.estoqueAMP.quantidade",
    "Remover": "parametros.estoqueAMP.remover"
  }

  constructor(service: EstoqueAmpService,
    toastr: ToastrService,
    router: Router,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService) {
    super(service, toastr, router);
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.carregarFiltrosParametros();
      this.router = router;
    });
  }

  ngOnInit() {
    this.buscar();
    this.cols = [
      { field: 'detalhe', header: '' },
      { field: 'nome_dealer', header: 'Dealer' },
      { field: 'partNumber', header: 'PartNumber' },
      { field: 'quantidade', header: 'Quantidade' },
      { field: 'remover', header: 'Remover' }
    ];

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.id_dealer
      || this.filtros.partNumber
      || this.filtros.quantidade;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  buscar() {
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.carregando = true;

    this.service.buscar(objFiltro)
      .then(res => {
        this.estoqueAMP = res.dados;

        this.carregando = false;
      });
  }


  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.service ? this.first === (this.service.length - this.rows) : true;
  }

  isFirstPage(): boolean {
    return this.service ? this.first === 0 : true;
  }

  visualizar(registro) {
    const retorno: RetornoSelecao = new RetornoSelecao();
    retorno.novoCadastro = false;
    retorno.registro = registro;
    this.ver(retorno);
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

  ngAfterViewChecked() {
    if (this.translate.currentLang === 'gb') {
      this.translate.use('br');
      this.translate.use('gb');
    }
    this.getTranslate('');
    this.cdRef.detectChanges();
  }

  marcarRemoverSelecionados(dados) {
    if (this.removeSelecionado.indexOf(dados.id) == -1) {
      this.removeSelecionado.push(dados.id);
    } else {
      this.removeSelecionado.splice(this.removeSelecionado.indexOf(dados.id), 1);
    }
  }

  RemoverSelecionados() {
    for (let item of this.removeSelecionado) {
      this.service.excluir(item);
    }
    const mensagem = 'Registro(s) selecionado(s) sendo Excluido(s)';
    this.toastr.success(mensagem, 'Excluido(s)');
    this.removeSelecionado = [];
    setTimeout(() => {
      this.buscar();
    }, 3000);

  }

}
